if (!customElements.get('description-clamp')) {
  customElements.define(
    'description-clamp',
    class DescriptionClamp extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-description-content]');
        this.button = this.querySelector('[data-description-toggle]');
        if (!this.content || !this.button) return;

        this.showMoreLabel = this.button.dataset.labelMore;
        this.showLessLabel = this.button.dataset.labelLess;

        this.button.addEventListener('click', this.toggle.bind(this));
        this.boundCheckOverflow = this.checkOverflow.bind(this);
        window.addEventListener('resize', this.boundCheckOverflow);
        window.addEventListener('load', this.boundCheckOverflow);
        requestAnimationFrame(this.boundCheckOverflow);
      }

      checkOverflow() {
        const isExpanded = this.content.classList.contains('description-clamp__content--expanded');
        if (isExpanded) return;
        const isOverflowing = this.content.scrollHeight > this.content.clientHeight + 1;
        this.button.hidden = !isOverflowing;
      }

      toggle() {
        const isExpanded = this.content.classList.toggle('description-clamp__content--expanded');
        this.button.textContent = isExpanded ? this.showLessLabel : this.showMoreLabel;
        this.button.setAttribute('aria-expanded', String(isExpanded));

        if (!isExpanded) {
          this.content.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }
  );
}
